import request from '../utils/request';
//展商直播

//展商直播列表
export function getliveList(data) {
    return request({
        url: '/frontExhibitor/zsLive/list',
        method: 'get',
        params: data,
    });
}
